let CacheUser = {
    zongcai: {
        name: '林文珏',
        img: '/upload/17f0c98c7b2a4fb49756d807194acf42.jpg'
    },
    caiwu: {
        name: '范小丽',
        img: '/upload/2f8e374ccfe04a738850becafc1c7f11.jpg'
    },
    caiwujingli: {
        name: '肖珂',
        img: '/upload/f95d7bc997e5474ab70316b121fee614.jpg'
    },
    zongjingban: {
        name: '廖松坤',
        img: '/upload/365a867c1857437f92f70e282c48d9a1.jpg'
    },
    chuna: {
        name: '廖伟君',
        img: '/upload/649acfc471524cda9f3d71ce9d8b0a85.jpg'
    },
    server: {
        name: '江山',
        img: '/upload/db63ecef2d74449f9e5762bd0b65f6c7.jpg'
    },
    yunyingjingli: {
        name: '曹海琴',
        img: '/upload/c23434ae85d244f083e3165bc80497e4.jpg'
    },
    gongyinglianZhuguan:{
        name: '欧江海',
        img: '/upload/e3a7d062cca642388cca1e2c10fbb204.jpg'
    }
}
export default CacheUser
